/**
 * Custom Discount Fix - Asegura que los descuentos personalizados funcionen con cambios de variante
 */
(function() {
  // Función para inicializar descuentos en todos los elementos de precio
  function initializeDiscounts() {
    const priceElements = document.querySelectorAll('.t4s-product-price[data-pr-price]');
    priceElements.forEach(function(priceElement) {
      const hasCustomDiscount = priceElement.getAttribute('data-custom-discount') === 'true';
      const hasWholesaleDiscount = priceElement.getAttribute('data-wholesale-discount') === 'true';
      
      if (hasCustomDiscount) {
        applyCustomDiscount(priceElement);
      } else if (hasWholesaleDiscount) {
        applyWholesaleDiscount(priceElement);
      }
    });
  }
  
  // Escuchar eventos de cambio de variante
  document.addEventListener('DOMContentLoaded', function() {
    // Aplicar descuentos iniciales
    initializeDiscounts();
    
    // Escuchar el evento del tema cuando cambia la variante
    document.addEventListener('variant:changed', function(event) {
      handleVariantChange(event);
    });
    
    // También escuchar cambios en el formulario de producto
    const productForms = document.querySelectorAll('[data-product-featured]');
    productForms.forEach(function(form) {
      const variantSelect = form.querySelector('select[name="id"]');
      if (variantSelect) {
        variantSelect.addEventListener('change', function() {
          setTimeout(function() {
            updatePriceWithDiscounts(form);
          }, 100);
        });
      }
    });
    
    // Observar cambios en el DOM para quick view y otros contenidos dinámicos
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          // Verificar si se agregaron elementos con precios
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Es un elemento
              // Buscar elementos de precio dentro del nodo agregado
              const priceElements = node.querySelectorAll ? node.querySelectorAll('.t4s-product-price[data-pr-price]') : [];
              if (priceElements.length > 0) {
                setTimeout(function() {
                  priceElements.forEach(function(priceElement) {
                    const hasCustomDiscount = priceElement.getAttribute('data-custom-discount') === 'true';
                    const hasWholesaleDiscount = priceElement.getAttribute('data-wholesale-discount') === 'true';
                    
                    if (hasCustomDiscount) {
                      applyCustomDiscount(priceElement);
                    } else if (hasWholesaleDiscount) {
                      applyWholesaleDiscount(priceElement);
                    }
                  });
                }, 200);
              }
              // También verificar si el nodo mismo es un elemento de precio
              if (node.classList && node.classList.contains('t4s-product-price') && node.hasAttribute('data-pr-price')) {
                setTimeout(function() {
                  const hasCustomDiscount = node.getAttribute('data-custom-discount') === 'true';
                  const hasWholesaleDiscount = node.getAttribute('data-wholesale-discount') === 'true';
                  
                  if (hasCustomDiscount) {
                    applyCustomDiscount(node);
                  } else if (hasWholesaleDiscount) {
                    applyWholesaleDiscount(node);
                  }
                }, 200);
              }
            }
          });
        }
      });
    });
    
    // Observar cambios en el body
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  });
  
  function handleVariantChange(event) {
    if (event.detail && event.detail.currentVariant) {
      const variant = event.detail.currentVariant;
      const container = event.target;
      updatePriceWithDiscounts(container, variant);
    }
  }
  
  function updatePriceWithDiscounts(container, variant) {
    const priceElement = container.querySelector('.t4s-product-price[data-pr-price]');
    if (!priceElement) return;
    
    const hasCustomDiscount = priceElement.getAttribute('data-custom-discount') === 'true';
    const hasWholesaleDiscount = priceElement.getAttribute('data-wholesale-discount') === 'true';
    
    if (!hasCustomDiscount && !hasWholesaleDiscount) {
      // Si no hay descuentos personalizados, dejar que el tema maneje el precio normalmente
      return;
    }
    
    // Esperar a que el tema actualice el precio base
    setTimeout(function() {
      if (hasCustomDiscount) {
        applyCustomDiscount(priceElement);
      } else if (hasWholesaleDiscount) {
        applyWholesaleDiscount(priceElement);
      }
    }, 150);
  }
  
  function applyCustomDiscount(priceElement) {
    const discountPercentage = parseFloat(priceElement.getAttribute('data-discount-percentage'));
    const originalPriceColor = priceElement.getAttribute('data-original-price-color');
    const discountedPriceColor = priceElement.getAttribute('data-discounted-price-color');
    const badgeBgColor = priceElement.getAttribute('data-badge-bg-color');
    const badgeTextColor = priceElement.getAttribute('data-badge-text-color');
    
    if (!discountPercentage) return;
    
    // Obtener el precio actual del texto
    const priceText = priceElement.textContent || priceElement.innerText;
    const priceMatch = priceText.match(/[\d,]+\.?\d*/);
    
    if (!priceMatch) return;
    
    // Extraer el precio numérico
    let currentPrice = priceMatch[0].replace(/,/g, '');
    currentPrice = parseFloat(currentPrice);
    
    if (isNaN(currentPrice)) return;
    
    // Calcular el precio con descuento
    const discountAmount = currentPrice * discountPercentage / 100;
    const discountedPrice = currentPrice - discountAmount;
    
    // Formatear precios
    const formattedOriginalPrice = formatMoney(currentPrice * 100);
    const formattedDiscountedPrice = formatMoney(discountedPrice * 100);
    
    // Actualizar el HTML
    priceElement.innerHTML = `
      <del style="color: ${originalPriceColor}; text-decoration: line-through;">${formattedOriginalPrice}</del> 
      <ins style="color: ${discountedPriceColor}; font-weight: bold;">${formattedDiscountedPrice}</ins>
      <span class="t4s-badge-price" style="background-color: ${badgeBgColor}; color: ${badgeTextColor}; padding: 2px 6px; border-radius: 3px; font-size: 12px; margin-left: 5px;">-${discountPercentage}%</span>
    `;
  }
  
  function applyWholesaleDiscount(priceElement) {
    const wholesalePercentage = parseFloat(priceElement.getAttribute('data-wholesale-percentage'));
    const wholesalePriceColor = priceElement.getAttribute('data-wholesale-price-color');
    const wholesaleLabelColor = priceElement.getAttribute('data-wholesale-label-color');
    const wholesaleOriginalPriceColor = priceElement.getAttribute('data-wholesale-original-price-color');
    
    if (!wholesalePercentage) return;
    
    // Obtener el precio actual del texto
    const priceText = priceElement.textContent || priceElement.innerText;
    const priceMatch = priceText.match(/[\d,]+\.?\d*/);
    
    if (!priceMatch) return;
    
    // Extraer el precio numérico
    let currentPrice = priceMatch[0].replace(/,/g, '');
    currentPrice = parseFloat(currentPrice);
    
    if (isNaN(currentPrice)) return;
    
    // Calcular el precio con descuento
    const discountAmount = currentPrice * wholesalePercentage / 100;
    const discountedPrice = currentPrice - discountAmount;
    
    // Formatear precios
    const formattedOriginalPrice = formatMoney(currentPrice * 100);
    const formattedDiscountedPrice = formatMoney(discountedPrice * 100);
    
    // Actualizar el HTML
    priceElement.innerHTML = `
      <del style="color: ${wholesaleOriginalPriceColor}; text-decoration: line-through; font-size: 14px;">${formattedOriginalPrice}</del>
      <span style="color: #8a9596; font-size: 14px; font-weight: normal; text-transform: uppercase;">PRECIO DE</span>
      <span style="background-color: ${wholesaleLabelColor}; color: white; padding: 2px 6px; border-radius: 10px; font-size: 10px; font-weight: bold; text-transform: uppercase; margin-right: 8px;">MAYOREO</span>
      <span style="color: ${wholesalePriceColor}; font-size: 14px; font-weight: bold;">${formattedDiscountedPrice}</span>
    `;
  }
  
  // Función helper para formatear dinero (usa el formato del tema)
  function formatMoney(cents) {
    if (typeof cents === 'string') {
      cents = cents.replace(/,/g, '');
    }
    
    // Usar la función de formateo del tema si está disponible
    if (window.T4SThemeSP && window.T4SThemeSP.Currency && window.T4SThemeSP.Currency.formatMoney) {
      return window.T4SThemeSP.Currency.formatMoney(cents);
    }
    
    // Fallback a formato simple
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = precision || 2;
      thousands = thousands || ',';
      decimal = decimal || '.';

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? decimal + parts[1] : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }
})();

